import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Defaults } from 'src/app/Utilities/defaults';
import { IVisitTypes } from 'src/app/models/IVisitTypes';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { DatePipe } from '@angular/common';

export interface DialogData {
  CVisit: string;
  CProvider: string;
  CDate: string;
  CLocId: number;
  lstTimeslots: any;
}

export interface hoursmin {
  value: string;
  viewValue: string;
}

export class customs {
  hour: string;
  minute: string;
  Apm: string;
}

@Component({
  selector: 'app-custom-slot',
  templateUrl: './custom-slot.component.html',
  styleUrls: ['./custom-slot.component.css']
})
export class CustomSlotComponent implements OnInit {
  customslots: FormGroup;

  hoursminArry: hoursmin[] = [];

  public Custtype: string;
  public CustRProvider: string;
  public CustDate: string;
  public CustLoc: number;
  public lstProviders: IUserDetails[];
  public lstVistTypes: IVisitTypes[];
  isDropDownDisable: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<CustomSlotComponent>,
    private formBuilder: FormBuilder, private sharedService: SharedService,
    private schedulerservice: SchedularServiceService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private datePipe: DatePipe) {

     this.Custtype = data.CVisit;
    this.CustRProvider = data.CProvider;
    this.CustDate = data.CDate;
    this.CustLoc = data.CLocId;
    this.hoursminArry = data.lstTimeslots;
    this.onload();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  ngOnInit() {
    this.customslots = this.formBuilder.group({
      customVisiType: [''],
      customDate: [''],
      customProvider: [''],
      hoursmin: ['', [Validators.required]],
    });
    this.fetchdata();
  }
  fetchdata() {
    var Custmdate = this.datePipe.transform(this.CustDate, 'MM/dd/yyyy');
    this.customslots.patchValue({
      customDate: Custmdate,
    });
  }

  async onload() {
    this.sharedService.getAllUsersByLoc(Defaults.doctorType, this.CustLoc).subscribe(data => {
      this.lstProviders = data;
      this.lstProviders = this.lstProviders.filter(a => a.userId == this.CustRProvider);
      this.customslots.patchValue({
        customProvider: this.lstProviders[0].fullName,
      });
    });


    this.schedulerservice.getVisitTypes().subscribe(data => {
      this.lstVistTypes = data;
      this.lstVistTypes = this.lstVistTypes.filter(a => a.visitId == this.Custtype);
      this.customslots.patchValue({
        customVisiType: this.lstVistTypes[0].visitType,
      });
    });
  }

  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }

  onSubmit() {

    var result = this.customslots.value.hoursmin; //(this.customslots.value.hour) + ":" + (this.customslots.value.minute) + " " + (this.customslots.value.Apm);
    if (result != "") {
      this.dialogRef.close(result);
    }
  }
}
